import type { SYSForm, TemplateResult, SYSDialog } from "../.."
import { html } from "../.."

import { SYSFormField } from "../forms/fieldapi"
import { _FocusState, SYSBaseElement } from "../sysbaseelement"
import { DialogClose } from "./dialogapi"

export type FormHandlingType = {
  formType: SYSForm
  formId?: any
  removeFormStateWhenClose?: boolean
  forceOverwrite?: boolean
  // set it true if you would like to have this.formState set inside a dialog
  isConnectedToDialog?: boolean
  creation?: {
    autoInitFormFields?: { [key: string]: SYSFormField }
    parentFormType?: SYSForm
    parentFormId?: any
    parentFieldKey?: string
    initialFocusFieldKey?: string
  }
}

export type DialogsState = {
  visible: boolean
  closing: boolean
  disabled?: boolean
  mainFormId?: string
  resolver?: any[]

  resolveValue?: any
  modal?: boolean
  zIndex: number
  data?: any
  formsHandling: FormHandlingType[]
  focus?: _FocusState
  //forceElementIdToFocusAfterClose?: string
  dialog: SYSDialog
  instance: any
}

export type DialogType =
  | "confirmation"
  | "error"
  | "success"
  | "warning"
  | "information"

export type DialogParts = {
  header?:
    | TemplateResult
    | TemplateResult[]
    | Promise<TemplateResult>
    | Promise<TemplateResult[]>
  title?: string
  body?:
    | TemplateResult
    | TemplateResult[]
    | Promise<TemplateResult>
    | Promise<TemplateResult[]>
  footer?:
    | TemplateResult
    | TemplateResult[]
    | Promise<TemplateResult>
    | Promise<TemplateResult[]>
  customClass?: string
  keyHandlerFn?: any
  dismissHandlerFn?: any
  closeOnDismiss?: boolean
  emptySpaceClickHandlerFn?: any
  closedCallbackFn?: any
  type?: DialogType
  instance?: any
}

export class SYSBaseDialog extends SYSBaseElement {
  //closedCallbackFn: any
  dismissCallbackFn: any
  scrollingDisabled: boolean

  constructor() {
    super()
  }

  getDialogTemplate = (
    dialogParts: DialogParts
  ): TemplateResult | Promise<TemplateResult> => {
    if (!this.closedCallbackFn && dialogParts.closedCallbackFn) {
      this.closedCallbackFn = dialogParts.closedCallbackFn
    }
    const defaultKeyHandler = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.stopPropagation()
        e.preventDefault()
        if (dialogParts.closeOnDismiss) {
          DialogClose(this.dialog, { instance: this.dialogInstance })
        } else if (dialogParts.dismissHandlerFn) {
          dialogParts.dismissHandlerFn()
        }
      }
    }

    // now put together the template

    let handleTopLevelClick = (e: Event) => {
      //e.stopImmediatePropagation()
      e.stopPropagation()
      //e.preventDefault()
      if (dialogParts.emptySpaceClickHandlerFn) {
        dialogParts.emptySpaceClickHandlerFn(e)
      }
    }

    let handleDismiss = (e: Event) => {
      e.stopPropagation()
      e.preventDefault()
      if (dialogParts.closeOnDismiss) {
        DialogClose(this.dialog, { instance: this.dialogInstance })
      } else if (dialogParts.dismissHandlerFn) {
        dialogParts.dismissHandlerFn()
      }
    }
    let keyHandler = defaultKeyHandler
    if (dialogParts.keyHandlerFn) {
      keyHandler = dialogParts.keyHandlerFn
    }

    let fullheader
    if (dialogParts.header || dialogParts.title || dialogParts.title === "") {
      let title
      if (dialogParts.title !== "") {
        title = html`
          <div class="fd-bar__element">
            <h4 class="fd-message-box__title">${dialogParts.title}</h4>
          </div>
        `
      }
      let header
      if (dialogParts.header) {
        title = html` <div class="fd-bar__element">${dialogParts.header}</div> `
      }
      let iconname: string
      if (dialogParts.type) {
        iconname = `message-${dialogParts.type}`
      }
      switch (dialogParts.type) {
        case "confirmation":
          iconname = "question-mark"
      }

      let icon
      if (iconname) {
        icon = html`<i class=${`sap-icon--${iconname}`}></i>`
      }

      fullheader = html`
        <header class="fd-bar fd-message-box__header ovl-dialog-header">
          <div class="fd-bar__left">${icon}${header} ${title}</div>
        </header>
      `
    }
    let body
    if (dialogParts.body) {
      body = html`<div class="fd-message-box__body ovl-dialog-body">
        ${dialogParts.body}
      </div>`
    }

    let footer
    if (dialogParts.footer) {
      footer = html`<footer
        class="fd-message-box__footer fd-bar fd-bar--footer ovl-dialog-footer"
      >
        <div class="fd-bar__right">${dialogParts.footer}</div>
      </footer>`
    }
    let customClass = ""
    if (dialogParts.customClass) {
      customClass = dialogParts.customClass
    }
    let typeClass = ""
    if (dialogParts.type) {
      typeClass = "fd-message-box--" + dialogParts.type
    }

    typeClass = `${typeClass} ovl_dlg_z_index_${this.zIndex}`
    return html`<div
      class=${`fd-message-box ${typeClass}  fd-message-box--active fadeInDialog`}
      @mousedown=${(e) => {
        if (e.which === 1) handleDismiss(e)
      }}
    >
      <section
        class=${`fd-message-box__content ovl-dialog ovl-dialog-${this.dialog} ${customClass}`}
        role="dialog"
        tabindex="-1"
        aria-modal="true"
        @mousedown=${(e) => {
          if (e.which === 1) {
            e.stopPropagation()
          }
        }}
        @click=${handleTopLevelClick}
        @keyup=${keyHandler}
        id=${`ovl-dialog-${this.dialog}-${this.dialogInstance}`}
      >
        ${fullheader} ${body} ${footer}
      </section>
    </div>`
  }
  async firstUpdated() {
    super.firstUpdated()
  }
}
